import React, { Fragment } from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, colors } from '@material-ui/core';
import { cx } from 'emotion';
import { Link } from 'react-router-dom';
import Label from '../../common/Label';
import gradients from '../../util/Gradients';
import { NumberHandler } from '../../util/NumberHandler';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxHeight: '89px',
    boxSizing: 'border-box',
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  avatar: {
    backgroundImage: gradients.green,
    height: 48,
    width: 48,
  },
  labeledH4: {
    display: 'inline-flex',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    alignItems: 'center',
  },
}));

const linkMap = {
  UnmappedDeals: {
    pathname: '/deals',
    state: {
      advancedFilters: ['unMapped'],
    },
  },
  CompleteDeals: {
    pathname: '/deals',
    state: {
      advancedFilters: ['complete'],
    },
  },
  TotalDeals: {
    pathname: '/deals',
  },
  AtRiskDeals: {
    pathname: '/deals',
    state: {
      advancedFilters: ['atRisk'],
    },
  },
};

function TopCard({ className, stat, showNet, ...rest }) {
  const {
    GrossAmount: grossAmount,
    NetAmount: netAmount,
    PercentChange: percent,
    Quantity: quantity,
    StatType,
  } = stat;
  const to = linkMap[StatType];
  const title = StatType.replace(/([A-Z])/g, ' $1').trim();
  const classes = useStyles();

  const ConditionalLink = ({ children }) =>
    to ? (
      <Link style={{ textDecoration: 'none' }} to={to}>
        {children}
      </Link>
    ) : (
      <Fragment>{children}</Fragment>
    );

  // FIXME: undo
  const breakPercent = null;

  return (
    <ConditionalLink>
      <Card {...rest} className={cx(classes.root, className)}>
        <div className={classes.contentContainer}>
          <div className={classes.titleRow}>
            <Typography component="h3" gutterBottom variant="overline">
              {title}
            </Typography>
            {breakPercent && (
              <Label
                className={classes.label}
                color={percent < 0 ? colors.red[600] : colors.green[600]}
                variant="outlined"
              >
                {percent < 0 ? '-' : '+'}{' '}
                <NumberHandler num={percent} float={2} suffix="%" />
              </Label>
            )}
          </div>
          {showNet && (
            <div className={classes.details}>
              <Typography variant="h5" className={classes.labeledH4}>
                <span>Net: </span>
                <NumberHandler
                  num={netAmount}
                  currency="$"
                  float={2}
                  style={{ paddingLeft: '10px' }}
                />
              </Typography>
            </div>
          )}
          {!showNet && (
            <Typography variant="h5" className={classes.labeledH4}>
              <span>Gross: </span>
              <NumberHandler
                num={grossAmount}
                currency="$"
                float={2}
                style={{ paddingLeft: '10px' }}
              />
            </Typography>
          )}
        </div>
      </Card>
    </ConditionalLink>
  );
}

export default TopCard;

// <Avatar className={classes.avatar}>
//   <AttachMoneyIcon />
// </Avatar>;
